import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { concatMap, map, Observable, startWith, takeWhile } from 'rxjs';
import { MweConstants } from 'src/app/constants/mwe-constants.service';
import { CareerService } from 'src/app/services/career.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { FileUploadService } from 'src/app/services/shared/file-upload.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { JobPreviewComponent } from '../job-preview/job-preview.component';
import { Currency } from 'src/app/models/master-data.model';
import { SpinnerService } from 'src/app/services/shared/spinner.service';
import { SweetAlertService } from 'src/app/services/sweetalert.service';
import { BreadcrumbService } from 'src/app/services/shared/breadcrumb.service';
import { V } from '@angular/cdk/keycodes';

export const multiRangeValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
  const experienceFrom = group.get('experienceFrom')?.value;
  const experienceTo = group.get('experienceTo')?.value;
  const salaryFrom = group.get('salaryFrom')?.value;
  const salaryTo = group.get('salaryTo')?.value;

  const errors: any = {};

  if (experienceFrom != null && experienceTo != null && parseFloat(experienceFrom) > parseFloat(experienceTo)) {
    errors.experienceRangeInvalid = true;
  }

  if (salaryFrom != null && salaryTo != null && parseFloat(salaryFrom) > parseFloat(salaryTo)) {
    errors.salaryRangeInvalid = true;
  }

  return Object.keys(errors).length ? errors : null;
};

@Component({
  selector: 'app-post-job',
  templateUrl: './post-job.component.html',
  styleUrls: ['./post-job.component.scss']
})
export class PostJobComponent implements OnInit {

  @Output() done = new EventEmitter<boolean>();
  @Input() from: string = '';

  @ViewChild('autoCompleteCountryInput', { static: false, read: MatAutocompleteTrigger }) autoCompleteCountryInput!: MatAutocompleteTrigger;

  @ViewChild('autoCompleteStateInput', { static: false, read: MatAutocompleteTrigger }) autoCompleteStateInput!: MatAutocompleteTrigger;

  @ViewChild('autoCompleteCityInput', { static: false, read: MatAutocompleteTrigger }) autoCompleteCityInput!: MatAutocompleteTrigger;

  @ViewChild('skillInput', { read: MatAutocompleteTrigger }) skillInputTrigger!: MatAutocompleteTrigger;
@ViewChild('tagInput', { read: MatAutocompleteTrigger }) tagInputTrigger!: MatAutocompleteTrigger;

  hideCompanyDetails = false;

  isFileInputClickedImage = false;
  isFileInputClickedCompanyLogo = false;
  fileSizeErrorImage = false;
  fileSizeErrorCompanyLogo = false;
  previewImage: any = null;
  previewCompanyLogo: any = null;
  countryDropdown: any[] = [];
  stateDropdown: any[] = [];
  cityDropdown: any[] = [];
  continents!: any[];
  countries!: any[];
  states!: any[];
  cities!: any[];
  jobCategories!: any[];
  specialities!: any[];
  jobSkills!: any[];
  jobTypes!: any[];
  careerLevels!: any[];
  degreeLevels!: any[];
  jobTagOptions!: any[];
  filteredCurrencies!: Observable<Currency[]>;
  filteredJobCategories!: Observable<any[]>;
  filteredSpecialities!: Observable<any[]>;
  filteredSkills!: Observable<any[]>;
  filteredJobTypes!: Observable<any[]>;
  filteredCareerLevels!: Observable<any[]>;
  filteredDegreeLevels!: Observable<any[]>;
  filteredTags!: Observable<any[]>;
  filteredSalaryRanges!: Observable<any[]>;
  currencies: Currency[] = [];
  currencySelected: boolean = false;
  skillsInputControl = new FormControl('', Validators.required);
  tagsInputControl = new FormControl('', Validators.required);
  masterDataTypes: string[] = ['jobCategory', 'speciality', 'jobType', 'careerLevel', 'degreeLevel', 'jobTag'];
  masterDataNames: string[] = ['Job Category', 'Speciality', 'Job Type', 'Career Level', 'Degree Level', 'Job Tags'];

  jobTagOptionsLength: number = 0;
  salaryRanges: any[] = [];

  showOtherCategoryField = false;
  isUpdateJob = false;
  currentJobPost: any;

  postJobForm = new FormGroup({
    title: new FormControl('', Validators.required),
    image: new FormControl('', Validators.required),
    companyLogo: new FormControl('', Validators.required),
    category: new FormControl('', Validators.required),
    speciality: new FormControl('', Validators.required),
    skills: new FormControl([]),
    jobType: new FormControl('', Validators.required),
    careerLevel: new FormControl('', Validators.required),
    experienceFrom: new FormControl('',[Validators.required, Validators.pattern(/^(?:[1-9]\d{0,1}(\.\d{1,2})?|0(\.\d{1,2})?)$/)]),
    experienceTo: new FormControl('',[Validators.required, Validators.pattern(/^(?:[1-9]\d{0,1}(\.\d{1,2})?|0(\.\d{1,2})?)$/)]),
    degreeLevel: new FormControl('', Validators.required),
    tags: new FormControl([]),
    description: new FormControl('', Validators.required),
    content: new FormControl('', Validators.required),
    jobDetails: new FormControl('', Validators.required),
    company: new FormControl('', Validators.required),
    postedBy: new FormControl('', Validators.required),
    postedEmail: new FormControl('', [Validators.required, Validators.email]),
    totalPositions: new FormControl('', [Validators.required,Validators.pattern('^[0-9]*$')]),
    address: new FormControl('', Validators.required),
    country: new FormControl('', Validators.required),
    state: new FormControl('', Validators.required),
    city: new FormControl('', Validators.required),
    salaryCurrency: new FormControl('', Validators.required),
    salaryRange: new FormControl('', Validators.required),
    salaryFrom: new FormControl(null as any, [Validators.required,Validators.pattern('^[0-9]*$')]),
    salaryTo: new FormControl(null as any, [Validators.required,Validators.pattern('^[0-9]*$')]),
    applicationStartDate: new FormControl('', Validators.required),
    applicationCloseDate: new FormControl('', Validators.required),
    hideSalary: new FormControl(false, Validators.required),
    postAnonymously: new FormControl(false, Validators.required),
  }, { validators: multiRangeValidator });
  otherMasterData=new FormGroup({
    otherCategory: new FormControl('',Validators.required),
    otherSpeciality: new FormControl('',Validators.required),
    otherSkills: new FormControl('',Validators.required),
    otherJobType: new FormControl('',Validators.required),
    otherCarrerLevel: new FormControl('',Validators.required),
    otherDegreeLevel: new FormControl('',Validators.required),
    otherTag: new FormControl('',Validators.required),
  })

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '10rem',
    minHeight: '0rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
    toolbarHiddenButtons: [
      [
        'undo',
        'redo',
        'strikeThrough',
        'subscript',
        'superscript',
        'justifyLeft',
        'justifyCenter',
        'justifyRight',
        'justifyFull',
        'indent',
        'outdent',
        'heading',
        'fontName'
      ],
      [
        'fontSize',
        'textColor',
        'backgroundColor',
        'customClasses',
        'link',
        'unlink',
        'insertImage',
        'insertVideo',
        'insertHorizontalRule',
        'removeFormat',
        'toggleEditorMode'
      ]
    ]
  };
onCitySelected: any;

  constructor(private readonly masterDataService: MasterDataService, private fileUploadService: FileUploadService,private breadcrumbService: BreadcrumbService,
    private careerService: CareerService, private readonly snackbarService: SnackbarService,
    private readonly router: Router,private spinnerService: SpinnerService, private route: ActivatedRoute,private dialog: MatDialog,private sweetAlertService: SweetAlertService) {

  }

  async ngOnInit(): Promise<void> {
    this.spinnerService.showSpinner();
    this.loadMasterData();
    await this.loadCurrencies();
    this.setupCategoryAutocomplete();
    this.setupSpecialityAutocomplete();
    this.setupSkillsAutocomplete();
    this.setupJobTypeAutocomplete();
    this.setupCareerLevelAutocomplete();
    this.setupDegreeLevelAutocomplete();
    this.setupTagsAutocomplete();
    this.setupSalaryRangeAutocomplete();
    this.onUpdateJobPost();
    this.getCountries(null);
    this.postJobForm.get('country')?.valueChanges.subscribe((data: any) => {
      if (data) {
        this.getCountries({ startsWith: data });
      }
      else {
        this.getCountries(null);
      }
    });

    if(this.from !== 'post' && this.from !=='' ){
      this.isUpdateJob = true;
    }
    
    this.postJobForm.get('state')?.valueChanges.subscribe((data: any) => {
      if (this.postJobForm.get('country')) {
        if (data) {
          this.getStatesByCountryName({ countryName: this.postJobForm.get('country')?.value, startsWith: data });
        } else {
          this.getStatesByCountryName({ countryName: this.postJobForm.get('country')?.value });
        }
      }
    });
    this.postJobForm.get('city')?.valueChanges.subscribe((data: any) => {
      if (this.postJobForm.get('state')?.value) {
        if (data) {
          this.getCityiesByStateName({ stateName: this.postJobForm.get('state')?.value, startsWith: data });
        } else {
          this.getCityiesByStateName({ stateName: this.postJobForm.get('state')?.value });
        }
      }
      else {
        if (data) {
          this.getCityiesByStateName({ startsWith: data });
        }
        else {
          this.getCityiesByStateName(null);
        }
      }
    });
    this.postJobForm.get('salaryCurrency')?.setErrors(null);  
    
  this.setupCurrencyAutocomplete();
  this.spinnerService.hideSpinner();
  }

  async showSalaryRanges(){
    this.masterDataService.getSalaryRanges().subscribe((res: any)=>{
      let salaryRanges = res.data.map((d: any)=> d.salaryRange);
      this.salaryRanges = [...new Set(salaryRanges)].sort((a:any, b:any) => a.localeCompare(b));
    })
  }
capitalizeFirstLetter() {
    let titleControl = this.postJobForm.get('title');
  
    if (titleControl && titleControl.value) {
      let value = titleControl.value;
      let newValue = value.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
      titleControl.setValue(newValue, { emitEvent: false });
    }
  }
  onCurrencySelected(event: MatAutocompleteSelectedEvent): void {
    const selectedCurrency: Currency = event.option.value;
    this.postJobForm.get('salaryCurrency')!.setValue(selectedCurrency.currency);
    this.postJobForm.get('salaryCurrency')?.setErrors(null);
    this.currencySelected = true;
  }
  onCategorySelected(event: MatAutocompleteSelectedEvent) {
    if(event.option.value=='other'){
      this.showOtherCategoryField=true;
    }else[
      this.showOtherCategoryField=false
    ]
    this.postJobForm.get('category')?.setValue(event.option.value);
  }
  
 showOtherSpecialityField=false;
  onSpecialitySelected(event: MatAutocompleteSelectedEvent) {
    if(event.option.value=='other'){
      this.showOtherSpecialityField=true;
    }else{
      this.showOtherSpecialityField=false;
    }
    this.postJobForm.get('speciality')?.setValue(event.option.value);
  }
  showOtherSkillField=false;
  onSkillSelected(event: MatAutocompleteSelectedEvent) {
    if(event.option.value=='other'){
      this.showOtherSkillField=true;
    }else{
      this.showOtherSkillField=false;
    }
    const skills = this.postJobForm.get('skills')?.value || [];
    const newSkill = event.option.value as never;
    if (!skills.includes(newSkill)) {
      skills.push(newSkill);
      this.postJobForm.get('skills')?.setValue(skills);
    }
  
    this.skillsInputControl.setValue('');
    if (this.skillInputTrigger) {
      this.skillInputTrigger.closePanel();
    }
    if (skills.length > 0) {
      this.skillsInputControl.setErrors(null);
    }
  }
showJobTypeField=false;
  onJobTypeSelected(event: MatAutocompleteSelectedEvent) {
    const value = event.option.value;
    if(value?.toLowerCase()==='other'){
      this.showJobTypeField=true;
    }else{
      this.showJobTypeField=false;
    }
    this.postJobForm.get('jobType')?.setValue(event.option.value);
  }
  showOtherCarrerLevelField=false;  
  onCareerLevelSelected(event: MatAutocompleteSelectedEvent) {
    const value = event.option.value;
    if(value?.toLowerCase()=='others'){
      this.showOtherCarrerLevelField=true;
    }else{
      this.showOtherCarrerLevelField=false;
    }
    this.postJobForm.get('careerLevel')?.setValue(event.option.value);
  }
  showOtherDegreeLevelField=false;
  onDegreeLevelSelected(event: MatAutocompleteSelectedEvent) {
    const value = event.option.value;
    if(value?.toLowerCase()=='other'){
      this.showOtherDegreeLevelField=true;
    }else{
      this.showOtherDegreeLevelField=false;
    }
    this.postJobForm.get('degreeLevel')?.setValue(event.option.value);
  }
  showOtherTagField=false;
  
  onTagSelected(event: MatAutocompleteSelectedEvent) {
    const value = event.option.value;
    if(value?.toLowerCase()=='other'){
      this.showOtherTagField=true;
    }
    const tags = this.postJobForm.get('tags')?.value || [];
    const newTag = event.option.value as never;
    if (!tags.includes(newTag)) {
      tags.push(newTag);
      this.postJobForm.get('tags')?.setValue(tags);
    }
    this.tagsInputControl.setValue('');
    if (this.tagInputTrigger) {
      this.tagInputTrigger.closePanel();
    }
    if (tags.length > 0) {
      this.tagsInputControl.setErrors(null);
    }
  }
  onSalaryRangeSelected(event: MatAutocompleteSelectedEvent) {
    this.postJobForm.get('salaryRange')?.setValue(event.option.value);
  }
  
    removeSkill(index: number): void {
      const skills = this.postJobForm.get('skills')?.value || [];
      skills.splice(index, 1);
      this.postJobForm.get('skills')?.setValue(skills);
      if (skills.length < 1) {
        this.skillsInputControl.setErrors({'required': true});
        this.skillsInputControl.markAsTouched();
        this.skillsInputControl.updateValueAndValidity();
      } else {
        this.skillsInputControl.setErrors(null);
      }
  }
  
  private _validateCurrency(value: string): boolean {
    return this.currencies?.some(option => option.currency.toLowerCase() === value.toLowerCase());
  }
  
  setupCurrencyAutocomplete() {
    this.filteredCurrencies = this.postJobForm.get('salaryCurrency')!.valueChanges.pipe(
      startWith(''),
      map(value => {
        this.currencySelected = false;
     
        if (typeof value === 'string' && !this._validateCurrency(value)) {
          this.postJobForm.get('salaryCurrency')?.setErrors({ 'invalidCurrency': true });
        } else {
          this.postJobForm.get('salaryCurrency')?.setErrors(null);
          const uppercaseValue = typeof value === 'string' ? value.toUpperCase() : value;
          if(uppercaseValue){
          this.postJobForm?.get('salaryCurrency')?.setValue(uppercaseValue, { emitEvent: false });}
          this.currencySelected = true;
        }
       
        return typeof value === 'string' ? this._filterCurrencies(value) : this.currencies.slice();
      })
    );
  }
  
  private setupCategoryAutocomplete() {
    this.filteredJobCategories = this.postJobForm.get('category')!.valueChanges.pipe(
      startWith(''),
      map((value:any) => this._filterOptions(value, this.jobCategories, 'categoryName'))
    );
  }
  private setupSpecialityAutocomplete() {
    this.filteredSpecialities = this.postJobForm.get('speciality')!.valueChanges.pipe(
      startWith(''),
      map((value:any) => this._filterOptions(value, this.specialities, 'specialty'))
    );
  }
  
  private setupSkillsAutocomplete() {
    this.filteredSkills = this.skillsInputControl.valueChanges.pipe(
      startWith(''),
      map((value: any) => this._filterOptions(value, this.jobSkills, 'name'))
    );
  }
  
  private setupJobTypeAutocomplete() {
    this.filteredJobTypes = this.postJobForm.get('jobType')!.valueChanges.pipe(
      startWith(''),
      map((value:any) => this._filterOptions(value, this.jobTypes, 'jobType'))
    );
  }
  
  private setupCareerLevelAutocomplete() {
    this.filteredCareerLevels = this.postJobForm.get('careerLevel')!.valueChanges.pipe(
      startWith(''),
      map((value:any) => this._filterOptions(value, this.careerLevels, 'experienceLevel'))
    );
  }

  private setupDegreeLevelAutocomplete() {
    this.filteredDegreeLevels = this.postJobForm.get('degreeLevel')!.valueChanges.pipe(
      startWith(''),
      map((value:any) => this._filterOptions(value, this.degreeLevels, 'degreeLevel'))
    );
  }
  
  private setupTagsAutocomplete() {
    this.filteredTags = this.tagsInputControl.valueChanges.pipe(
      startWith(''),
      map((value:any) => this._filterOptions(value, this.jobTagOptions, 'jobTags'))
    );
  }
  
  private setupSalaryRangeAutocomplete() {
    this.filteredSalaryRanges = this.postJobForm?.get('salaryRange')!.valueChanges.pipe(
      startWith(''),
      map((value:any) => this._filterOptions(value, this.salaryRanges, ''))
    );
  }
  private _filterOptions(value: string, options: any[], key: string | null): any[] {
    const filterValue = value?.toLowerCase() || '';
    return options?.filter(option => {
      const optionValue = key ? option[key] : option;
      return optionValue?.toLowerCase().includes(filterValue);
    });
  }
  
  private _filterCurrencies(value: string): Currency[] {
    const filterValue = value.toLowerCase();
    return this.currencies.filter(option => option.currency.toLowerCase().includes(filterValue));
  }

  
  displayCurrency(currency: string | null): string {
    return currency ? currency : ''; 
  }
  
  

  async loadCurrencies(): Promise<void> {
    return new Promise((resolve, reject) => {
      let pageNumber = 0;
      const pageSize = 125;
      let allCurrencies: Currency[] = [];
      let morePages = true;
  
      this.masterDataService.getCurrencies(pageNumber, pageSize)
        .pipe(
          takeWhile(() => morePages),
          concatMap(response => {
            if (response.data.length === 0) {
              morePages = false; 
              return ([]); 
            }
            allCurrencies = allCurrencies.concat(response.data);
            pageNumber++;
            return this.masterDataService.getCurrencies(pageNumber, pageSize);
          }),
        )
        .subscribe(data => {
          allCurrencies = allCurrencies.concat(data.data);
          this.currencies = allCurrencies;
          resolve();
        });
    });
  }
 
  async onUpdateJobPost() {
    if(this.from !== 'post' && this.from !== '' ) {
      await this.getJobPostById(this.from);
      return
    }
    const jobPostId = this.router.url.split('?')[0].split('/').pop();
    if (this.router.url.includes('update-job') && jobPostId !== undefined && jobPostId !== null) {
      this.isUpdateJob = true;
      await this.getJobPostById(jobPostId);
      this.breadcrumbService.setBreadcrumbs(['Dashboard', 'Edit Job']);
    }
  }

  removeTag(index: number): void {
    const tags = this.postJobForm.get('tags')?.value || [];
    tags.splice(index, 1);
    this.postJobForm.get('tags')?.setValue(tags);
    if (tags.length < 1) {
      this.tagsInputControl.setErrors({'required': true});
      this.tagsInputControl.markAsTouched();
      this.tagsInputControl.updateValueAndValidity();
    } else {
      this.tagsInputControl.setErrors(null);
    }
  }
  

  private async getJobPostById(jobPostId: any) {
    this.careerService.executeGetRequestURL(MweConstants.getJobPostUrl.concat('/', jobPostId), null).subscribe({
      next: (response) => {
        if (response && response?.data) {
          const data = response?.data;
          this.currentJobPost = data;
          const formData: any = this.mapJobFormFromRequest(data);
          this.postJobForm.setValue(formData);
          this.isFileInputClickedImage = true;
          this.isFileInputClickedCompanyLogo = true;
          this.previewImage = data.image;
          this.previewCompanyLogo = data.companyLogo;
        }
      }, error: (error) => {
        this.snackbarService.openSnackBar(error.error.error, '');
      }
    });
  }

  
  isImageFile(file: File): boolean {
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.svg'];
    const fileName = file.name.toLowerCase();
    return imageExtensions.some(ext => fileName.endsWith(ext));
  }

  validateFile(file: File, field: 'image' | 'companyLogo'): boolean {
    if (!this.isImageFile(file)) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid file type',
        text: 'Please select only image files (JPG, JPEG, PNG, GIF, SVG)'
      });
      return false;
    }

    if (file.size > 10 * 1024 * 1024) {
      if (field === 'image') {
        this.fileSizeErrorImage = true;
      } else {
        this.fileSizeErrorCompanyLogo = true;
      }
      return false;
    }

    if (field === 'image') {
      this.fileSizeErrorImage = false;
      this.isFileInputClickedImage = true;
    } else {
      this.fileSizeErrorCompanyLogo = false;
      this.isFileInputClickedCompanyLogo = true;
    }

    return true;
  }

  onFileSelected(event: Event, field: 'image' | 'companyLogo') {
    const inputElement = event.target as HTMLInputElement;
    const files = inputElement.files;
    if (!files || files.length === 0) return;

    const file = files[0];
    if (this.validateFile(file, field)) {
      this.handleFiles(files, field, inputElement);
    } else {
      this.resetFileInput(inputElement);
    }
  }

  onDrop($event: DragEvent, inputElement: HTMLInputElement, field: 'image' | 'companyLogo') {
    $event.preventDefault();
    const files = $event.dataTransfer?.files;
    if (!files || files.length === 0) return;

    const file = files[0];
    if (this.validateFile(file, field)) {
      this.handleFiles(files, field, inputElement);
    }
  }
  resetFileInput(inputElement: HTMLInputElement): void {
    inputElement.value = '';
  }

  onDragOver($event: DragEvent){
    $event.preventDefault();
  }

  onDragLeave($event: DragEvent){
    $event.preventDefault();
  }

  handleFiles(files: FileList, formControlName: string, inputElement: HTMLInputElement) {
    if (!files || files.length === 0) return;

    const file = files[0];

    this.fileUploadService.uploadFilesAndGetUrls([file], 'destinationKey').subscribe({
        next: (urls: string[]) => {
            this.showFile(file, formControlName);
            this.postJobForm.get(formControlName)?.setValue(urls[0]);
            inputElement.value = '';
        },
        error: (error: any) => {
            this.snackbarService.openSnackBar(error.error?.error || 'File upload failed', '');
        }
    });
}
  showFile(file: File, formControlName: string) {
    if (!file) return;

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
        if (formControlName === 'image') {
            this.previewImage = reader.result as string;
            this.isFileInputClickedImage = true;
        } else if (formControlName === 'companyLogo') {
            this.previewCompanyLogo = reader.result as string;
            this.isFileInputClickedCompanyLogo = true;
        }
    };
}

  removeLogo(event: any) {
    if (event !== undefined && event !== null) {
      event.stopPropagation();
    }
    this.previewImage = null;
    this.postJobForm.get('image')?.setValue(null);
    this.isFileInputClickedImage = false;
    this.postJobForm.get('image')?.markAsTouched();
    this.postJobForm.get('image')?.updateValueAndValidity();
  }
  removeCompanyLogo(event: any) {
    if (event !== undefined && event !== null) {
      event.stopPropagation();
    }
    this.previewCompanyLogo = null;
    this.postJobForm.get('companyLogo')?.setValue(null);
    this.isFileInputClickedCompanyLogo = false;
    this.postJobForm.get('companyLogo')?.markAsTouched();
    this.postJobForm.get('companyLogo')?.updateValueAndValidity();
  }

  private async loadMasterData() {
    this.careerService.setCareersBreadCrumbs(['Dashboard', 'Post a Job']);
    this.loadCountries('');
    this.loadJobCategories();
    this.loadSpecialities();
    this.loadJobSkills();
    this.loadJobTypes();
    this.loadCareerLevels();
    this.loadDegreeLevels();
    this.loadJobTags();
    await this.showSalaryRanges();
  }

  getValue(formControlName: string) {
    const value = this.postJobForm.get(formControlName)?.value;

    if (value !== undefined && value !== null) {
      return value;
    } else {
      return null;
    }

  }

  private loadCountries(continentName: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const pageNumber = 0;
      const pageSize = 100;
      let allCountries: any[] = [];
  
      this.masterDataService.getCountries(pageNumber, pageSize, '', [continentName]).subscribe(
        res => {
          if (!res.data || res.data.length === 0) {
            allCountries = [];
          } else {
            allCountries = allCountries.concat(res.data);
          }
          this.countries = allCountries;
          resolve();
        },
        error => {
          this.countries = [];
          reject(error);
        }
      );
    });
  }

  loadJobCategories(): Promise<void> {
    return new Promise((resolve, reject) => {
      const pageNumber = 0;
      const pageSize = 100;
      let allJobCategories: any[] = [];
  
      this.masterDataService.getJobCategories(pageNumber, pageSize, '').subscribe(
        res => {
          if (!res.data || res.data.length === 0) {
            allJobCategories = [];
          } else {
            allJobCategories = allJobCategories.concat(res.data);
          }
          this.jobCategories = allJobCategories.sort((a, b) => a.categoryName.localeCompare(b.categoryName));
          resolve();
        },
        error => {
          this.jobCategories = [];
          reject(error);
        }
      );
    });
  }
  
  loadSpecialities(): Promise<void> {
    return new Promise((resolve, reject) => {
      const pageNumber = 0;
      const pageSize = 100;
      let allSpecialities: any[] = [];
  
      this.masterDataService.getSpecialities(pageNumber, pageSize, '').subscribe(
        res => {
          if (!res.data || res.data.length === 0) {
            allSpecialities = [];
          } else {
            allSpecialities = allSpecialities.concat(res.data);
          }
          this.specialities = allSpecialities;
          resolve();
        },
        error => {
          this.specialities = [];
          reject(error);
        }
      );
    });
  }
  

  loadJobSkills(): Promise<void> {
    return new Promise((resolve, reject) => {
      const pageNumber = 0;
      const pageSize = 100;
      let allJobSkills: any[] = [];
  
      this.masterDataService.getJobSkills(pageNumber, pageSize, '').subscribe(
        res => {
          if (!res.data || res.data.length === 0) {
            allJobSkills = [];
          } else {
            allJobSkills = allJobSkills.concat(res.data);
          }
          this.jobSkills = allJobSkills;
          resolve();
        },
        error => {
          this.jobSkills = [];
          reject(error);
        }
      );
    });
  }
  

  loadCareerLevels(): Promise<void> {
    return new Promise((resolve, reject) => {
      const pageNumber = 0;
      const pageSize = 100;
      let allCareerLevels: any[] = [];
  
      this.masterDataService.getCareerLevels(pageNumber, pageSize, '').subscribe(
        res => {
          if (!res.data || res.data.length === 0) {
            allCareerLevels = [];
          } else {
            allCareerLevels = allCareerLevels.concat(res.data);
          }
          this.careerLevels = allCareerLevels;
          resolve();
        },
        error => {
          this.careerLevels = [];
          reject(error);
        }
      );
    });
  }
  

  loadDegreeLevels(): Promise<void> {
    return new Promise((resolve, reject) => {
      const pageNumber = 0;
      const pageSize = 100;
      let allDegreeLevels: any[] = [];
  
      this.masterDataService.getDegreeLevels(pageNumber, pageSize, '').subscribe(
        res => {
          if (!res.data || res.data.length === 0) {
            allDegreeLevels = [];
          } else {
            allDegreeLevels = allDegreeLevels.concat(res.data);
          }
          this.degreeLevels = allDegreeLevels;
          resolve();
        },
        error => {
          this.degreeLevels = [];
          reject(error);
        }
      );
    });
  }
  

  loadJobTypes(): Promise<void> {
    return new Promise((resolve, reject) => {
      const pageNumber = 0;
      const pageSize = 100;
      let allJobTypes: any[] = [];
  
      this.masterDataService.getJobTypes(pageNumber, pageSize, '').subscribe(
        res => {
          if (!res.data || res.data.length === 0) {
            allJobTypes = [];
          } else {
            allJobTypes = allJobTypes.concat(res.data);
          }
          this.jobTypes = allJobTypes;
          resolve();
        },
        error => {
          this.jobTypes = [];
          reject(error);
        }
      );
    });
  }
  

  loadJobTags(): Promise<void> {
    return new Promise((resolve, reject) => {
      const pageNumber = 0;
      const pageSize = 100;
      let allJobTags: any[] = [];
  
      this.masterDataService.getJobTags(pageNumber, pageSize, '').subscribe(
        res => {
          if (!res.data || res.data.length === 0) {
            allJobTags = [];
          } else {
            allJobTags = allJobTags.concat(res.data);
          }
          this.jobTagOptions = allJobTags.sort((a, b) => (a.jobTags > b.jobTags ? 1 : -1));
          this.jobTagOptionsLength = this.jobTagOptions?.length;
          resolve();
        },
        error => {
          this.jobTagOptions = [];
          this.jobTagOptionsLength = 0;
          reject(error);
        }
      );
    });
  }
    masterDataList: { type: string, name: string }[] = [];

  onMasterDataChange(event: any, type: string) {  
    const value = event.target.value;
    if (value) {
      const index = this.masterDataList.findIndex(item => item.type === type);
      if (index !== -1) {
        this.masterDataList[index].name = value;
      } else {
        this.masterDataList.push({ type, name: value });
      }
    }
  }
  onSubmit() {
    Object.keys(this.postJobForm.controls).forEach(key => {
      const control = this.postJobForm.get(key);
      control?.markAsTouched();
    });
    this.skillsInputControl.markAsTouched();
    this.tagsInputControl.markAsTouched();
    if (this.postJobForm?.get('skills')?.value?.length === 0) {
      this.skillsInputControl.setErrors({'required': true});
    } else {
      this.skillsInputControl.setErrors(null);
    }
    if (this.postJobForm?.get('tags')?.value?.length === 0) {
      this.tagsInputControl.setErrors({'required': true});
    } else {
      this.tagsInputControl.setErrors(null);
    }
    if (this.postJobForm.valid) {
      const formData = { ...this.postJobForm.value };
      formData.salaryFrom = this.removeCommas(formData.salaryFrom);
      formData.salaryTo = this.removeCommas(formData.salaryTo);
      const body: any = { ...formData };
      body.description = this.stripHtmlTags(this.postJobForm.get('description')?.value);
      body.content = this.stripHtmlTags(this.postJobForm.get('content')?.value);
      body.jobDetails = this.stripHtmlTags(this.postJobForm.get('jobDetails')?.value);

      if (body.skills != undefined && body.skills.length > 0 && Array.isArray(body.skills)) {
        const skills: any = body.skills?.join(',');
        body.skills = skills;
      }

      if (body.tags != undefined && body.tags.length > 0 && Array.isArray(body.tags)) {
        const tags: any = body.tags?.join(',');
        body.tags = tags;
      }

      const userIdByRole = this.careerService.getUserIdBasedOnRole();
      if (this.isUpdateJob) {
        const jobPost: any = body;
        if (body.applicationStartDate) {
          const startDate = new Date(body.applicationStartDate);
          startDate.setDate(startDate.getDate() + 1);
          body.applicationStartDate = startDate;
        }
        
        if (body.applicationCloseDate) {
          const endDate = new Date(body.applicationCloseDate);
          endDate.setDate(endDate.getDate() + 1);
          body.applicationCloseDate = endDate;
        }
        jobPost.id = this.currentJobPost.id;
        jobPost.jobPostId = this.currentJobPost.jobPostId;
        jobPost.active = this.currentJobPost.active;
        jobPost.createdOn = new Date(this.currentJobPost.createdOn);
        jobPost.createdBy = this.currentJobPost.createdBy;
        this.careerService.executePutRequest(MweConstants.updateJobPostUrl + this.currentJobPost.id, body, userIdByRole).subscribe({
          next: (data: any) => {
            this.sweetAlertService.showSuccess('', 'Job Post Updated Successfully !!').then(result=>{
              this.onCancel();
            });
            
          }, error: (error: any) => {
            this.snackbarService.openSnackBar("An issue occured while updating Job post. Please try again later.", '');
          }
        });
      } else {
        if (body.applicationStartDate) {
          const startDate = new Date(body.applicationStartDate);
          startDate.setDate(startDate.getDate() + 1);
          body.applicationStartDate = startDate;
        }
        
        if (body.applicationCloseDate) {
          const endDate = new Date(body.applicationCloseDate);
          endDate.setDate(endDate.getDate() + 1);
          body.applicationCloseDate = endDate;
        }
        // body.otherMasterData = this.masterDataList
        this.careerService.executePostRequest(MweConstants.saveJobPostUrl, body, userIdByRole).subscribe({
          
          next: (data: any) => {
            Swal.fire('', 'Job Post Added Successfully !!', 'success');
            this.onCancel();
          }, error: (error: any) => {
            this.snackbarService.openSnackBar("An issue occured while creating Job post. Please try again later", '');
          }
        });
      }
    }

  }

  removeCommas(value: any): number {
    if (typeof value === 'string') {
      return Number(value.replace(/,/g, ''));
    }
    return value;
  }
  private stripHtmlTags(input: any): any {
    return input ? input.replace(/<font[^>]*>/g, '').replace(/<\/font>/g, '') : '';
  }
  

  onCancel() {
    if(this.from){
      this.done.emit(true);
      return;
    }
    this.removeLogo(null);
    this.postJobForm.reset();
    this.router.navigate([this.isUpdateJob ? '../..' : '../'], { relativeTo: this.route });
  }
  setJobFieldBasedOnType(dataList: any[], type: string, controlName: string, flagField: string): void {
    const values = dataList
      .filter(data => data.type === type)
      .map(data => data.name);
  
    if (values.length > 0) {
      const control = this.otherMasterData.get(controlName) as FormControl;
      console.log("control",control)
      console.log("values",values)
      if (control) {
        control.setValue(values.join(','));
      }
      (this as any)[flagField] = true;  
    }
  }
  
  mapJobFormFromRequest(jobPost: any) {
    this.masterDataList = jobPost.otherMasterData || [];
    this.setJobFieldBasedOnType(this.masterDataList, 'Job Category', 'otherCategory', 'showOtherCategoryField');
    this.setJobFieldBasedOnType(this.masterDataList, 'Speciality', 'otherSpeciality', 'showOtherSpecialityField');
    this.setJobFieldBasedOnType(this.masterDataList, 'Career Level', 'otherCarrerLevel', 'showOtherCarrerLevelField');
    this.setJobFieldBasedOnType(this.masterDataList, 'Degree Level', 'otherDegreeLevel', 'showOtherDegreeLevelField');
    this.setJobFieldBasedOnType(this.masterDataList, 'Job Type', 'otherJobType', 'showOtherJobTypeField');
    this.setJobFieldBasedOnType(this.masterDataList, 'Tag', 'otherTag', 'showOtherTagField');   
    return {
      title: jobPost.title,
      image: jobPost.image,
      companyLogo: jobPost.companyLogo,
      category: jobPost.category,
      speciality: jobPost.speciality,
      skills: this.convertStringToArray(jobPost.skills) || [],
      jobType: jobPost.jobType,
      careerLevel: jobPost.careerLevel,
      experienceFrom: jobPost.experienceFrom,
      experienceTo: jobPost.experienceTo,
      degreeLevel: jobPost.degreeLevel,
      tags: this.convertStringToArray(jobPost.tags) || [],
      description: jobPost.description,
      content: jobPost.content,
      jobDetails: jobPost.jobDetails,
      company: jobPost.company,
      postedBy: jobPost.postedBy,
      postedEmail: jobPost.postedEmail,
      totalPositions: jobPost.totalPositions,
      address: jobPost.address,
      city: jobPost.city,
      state: jobPost.state,
      country: jobPost.country,
      salaryCurrency: jobPost.salaryCurrency,
      salaryRange: jobPost.salaryRange,
      salaryFrom: jobPost.salaryFrom,
      salaryTo: jobPost.salaryTo,
      applicationStartDate: this.convertToDate(jobPost.applicationStartDate),
      applicationCloseDate: this.convertToDate(jobPost.applicationCloseDate),
      hideSalary: jobPost.hideSalary,
      postAnonymously: jobPost.postAnonymously
    }
  }

  private convertStringToArray(field: any) {
    return (field !== undefined && field !== null && field.length > 0) ? field.split(",") : [];
  }

  private convertToDate(field: any, isEndDate: boolean = false) {
    if (field !== undefined && field !== null) {
      const date = new Date(field);
      if (isEndDate) {
        date.setDate(date.getDate() + 1);
      }
      return date;
    }
    return null;
  }


  onCountrySelected(event: any) {
    this.getStatesByCountryName({ countryName: this.postJobForm.get('country')?.value });
    this.postJobForm.get('state')?.setValue('');
    this.postJobForm.get('city')?.setValue('');
  }

  onStateSelected(event: any) {
    this.getCityiesByStateName({ stateName: this.postJobForm.get('state')?.value });
    this.postJobForm.get('city')?.setValue('');
  }

  getCountries(params: any) {
    this.executeGetRequestURL(MweConstants.countryURL, params, 'countryDropdown');
  }
  getStatesByCountryName(params: any) {
    this.executeGetRequestURL(MweConstants.stateUrl, params, 'stateDropdown');
  }
  getCityiesByStateName(params: any) {
    this.executeGetRequestURL(MweConstants.cityUrl, params, 'cityDropdown');
  }
  executeGetRequestURL(url: string, params: any, type: string) {
    (this as any)[type] = [];
    this.masterDataService.executeGetRequestURL(url, params).subscribe(data => {
      if (data && data?.data && data.data.length > 0) {
        (this as any)[type] = data.data;
      }
    }, error => {
    })
  }

  onPreview() {
    if (this.postJobForm.valid) {
      const dialogRef = this.dialog.open(JobPreviewComponent, {
        width: '60%',
        data: this.postJobForm.value
      });
    } else {
      this.snackbarService.openSnackBar('Please fill all required fields before previewing.', '');
    }
  }
}